export class QuixoFailure {
    static NO_INSIDE_CLICK = () => $localize `You must pick a space from the edge of the board.`;
}
